import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import Calendar from "../calendar/Calendar";
import EventPopup from "../popup/EventPopup";
import PrivateEventPopup from "../popup/PrivateEventPopup";
import { GET_ALL_EVENTS, GET_ALL_USERS_EVENTS } from "../../gql/queries";
import CreateEventMultiStep from "./CreateEventMultiStep"

const CreateEvent = () => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedEvents, setSelectedEvents] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showPrivatePopup, setShowPrivatePopup] = useState(false);

    const { data: allEventsData } = useQuery(GET_ALL_EVENTS);
    const allEvents = allEventsData?.allEvents || [];

    const { data: userEventsData } = useQuery(GET_ALL_USERS_EVENTS);
    const userEvents = userEventsData?.allUsersEvents || [];
    const userEventIds = new Set(userEvents.map(event => event._id));

    const showModal = () => {
        const modal = document.querySelector(".modalParent");
        modal.style.visibility = "visible";
    };

    const closeModal = () => {
        const modal = document.querySelector(".modalParent");
        modal.style.visibility = "hidden";
    };

    const handleDateClick = (date, events) => {
        setSelectedDate(date);
        setSelectedEvents(events);

        const allPrivateNotInvited = events.every(event =>
            event.eventType === 'private' && !userEventIds.has(event._id)
        );
        if (allPrivateNotInvited) {
            setShowPrivatePopup(true);
        } else {
            setShowPopup(true);
        }
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        setShowPrivatePopup(false);
        setSelectedDate(null);
        setSelectedEvents([]);
    };

    return (
        <>
            <div className="modalParent">
                <div className="modalSuccessful">
                    <h3>Created Successfully!</h3>
                    <button className="ok" onClick={closeModal}>
                        <p>Close</p>
                    </button>
                </div>
            </div>
            <h1>Plan Your Event</h1>
            <div className="plan-event-container">
                <div className="calendar-wrapper">
                    <Calendar
                        events={allEvents}
                        onDateClick={handleDateClick}
                    />
                </div>

                <CreateEventMultiStep showModal={showModal} />

            </div>
            {showPopup && (
                <EventPopup
                    date={selectedDate}
                    events={selectedEvents}
                    userEventIds={userEventIds}
                    onClose={handleClosePopup}
                />
            )}
            {showPrivatePopup && (
                <PrivateEventPopup
                    events={selectedEvents}
                    onClose={handleClosePopup}
                />
            )}
        </>
    )
};

export default CreateEvent;